export const hockey_hoodie = {
  msrp: 64.99,
  infoLink: 'https://www.teamtriton.com/hockey-hoodie.html',
  items: [
    {
      number: 'HH100',
      hasModel: false,
    },
    {
      number: 'HH101',
      hasModel: false,
    },
    {
      number: 'HH102',
      hasModel: false,
    },
    {
      number: 'HH103',
      hasModel: false,
    },
    {
      number: 'HH104',
      hasModel: false,
    },
    {
      number: 'HH105',
      hasModel: false,
    },
    {
      number: 'HH106',
      hasModel: false,
    },
  ],
};
